import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Menu, X, ShoppingCart, Leaf } from 'lucide-react'

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <nav data-component-path="client/src/components/Navbar.jsx" data-component-line="9:5" data-component-id="client/src/components/Navbar.jsx:9:5" className="fixed w-full bg-white/95 backdrop-blur-sm shadow-md z-50">
      <div data-component-path="client/src/components/Navbar.jsx" data-component-line="10:7" data-component-id="client/src/components/Navbar.jsx:10:7" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/Navbar.jsx" data-component-line="11:9" data-component-id="client/src/components/Navbar.jsx:11:9" className="flex justify-between items-center h-20">
          <Link 
            to="/" 
            data-component-path="client/src/components/Navbar.jsx" 
            data-component-line="14:13" 
            data-component-id="client/src/components/Navbar.jsx:14:13"
            className="flex items-center gap-2 group"
          >
            <div data-component-path="client/src/components/Navbar.jsx" data-component-line="18:13" data-component-id="client/src/components/Navbar.jsx:18:13" className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center group-hover:bg-green-700 transition-colors duration-200">
              <Leaf data-component-path="client/src/components/Navbar.jsx" data-component-line="19:15" data-component-id="client/src/components/Navbar.jsx:19:15" className="w-7 h-7 text-white" />
            </div>
            <span data-component-path="client/src/components/Navbar.jsx" data-component-line="21:13" data-component-id="client/src/components/Navbar.jsx:21:13" className="text-2xl font-bold text-gray-900">Fresh Harvest</span>
          </Link>

          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="24:11" data-component-id="client/src/components/Navbar.jsx:24:11" className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              data-component-path="client/src/components/Navbar.jsx" 
              data-component-line="27:15" 
              data-component-id="client/src/components/Navbar.jsx:27:15"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              data-component-path="client/src/components/Navbar.jsx" 
              data-component-line="34:15" 
              data-component-id="client/src/components/Navbar.jsx:34:15"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
            >
              About
            </Link>
            <a 
              href="#products" 
              data-component-path="client/src/components/Navbar.jsx" 
              data-component-line="41:15" 
              data-component-id="client/src/components/Navbar.jsx:41:15"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
            >
              Products
            </a>
            <a 
              href="#contact" 
              data-component-path="client/src/components/Navbar.jsx" 
              data-component-line="48:15" 
              data-component-id="client/src/components/Navbar.jsx:48:15"
              className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
            >
              Contact
            </a>
            <button 
              data-component-path="client/src/components/Navbar.jsx" 
              data-component-line="55:15" 
              data-component-id="client/src/components/Navbar.jsx:55:15"
              className="h-11 px-6 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center gap-2 font-medium shadow-md hover:shadow-lg transition-all duration-200 focus:ring-4 focus:ring-green-300/50"
            >
              <ShoppingCart data-component-path="client/src/components/Navbar.jsx" data-component-line="59:15" data-component-id="client/src/components/Navbar.jsx:59:15" className="w-5 h-5 flex-shrink-0" />
              <span data-component-path="client/src/components/Navbar.jsx" data-component-line="60:15" data-component-id="client/src/components/Navbar.jsx:60:15">Cart (0)</span>
            </button>
          </div>

          <button
            data-component-path="client/src/components/Navbar.jsx" 
            data-component-line="65:13" 
            data-component-id="client/src/components/Navbar.jsx:65:13"
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          >
            {isOpen ? (
              <X data-component-path="client/src/components/Navbar.jsx" data-component-line="71:15" data-component-id="client/src/components/Navbar.jsx:71:15" className="w-6 h-6 text-gray-900" />
            ) : (
              <Menu data-component-path="client/src/components/Navbar.jsx" data-component-line="73:15" data-component-id="client/src/components/Navbar.jsx:73:15" className="w-6 h-6 text-gray-900" />
            )}
          </button>
        </div>

        {isOpen && (
          <div data-component-path="client/src/components/Navbar.jsx" data-component-line="79:11" data-component-id="client/src/components/Navbar.jsx:79:11" className="md:hidden py-4 border-t border-gray-200">
            <div data-component-path="client/src/components/Navbar.jsx" data-component-line="80:13" data-component-id="client/src/components/Navbar.jsx:80:13" className="flex flex-col gap-4">
              <Link 
                to="/" 
                data-component-path="client/src/components/Navbar.jsx" 
                data-component-line="83:17" 
                data-component-id="client/src/components/Navbar.jsx:83:17"
                className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
                onClick={() => setIsOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                data-component-path="client/src/components/Navbar.jsx" 
                data-component-line="91:17" 
                data-component-id="client/src/components/Navbar.jsx:91:17"
                className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
                onClick={() => setIsOpen(false)}
              >
                About
              </Link>
              <a 
                href="#products" 
                data-component-path="client/src/components/Navbar.jsx" 
                data-component-line="99:17" 
                data-component-id="client/src/components/Navbar.jsx:99:17"
                className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
                onClick={() => setIsOpen(false)}
              >
                Products
              </a>
              <a 
                href="#contact" 
                data-component-path="client/src/components/Navbar.jsx" 
                data-component-line="107:17" 
                data-component-id="client/src/components/Navbar.jsx:107:17"
                className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200"
                onClick={() => setIsOpen(false)}
              >
                Contact
              </a>
              <button 
                data-component-path="client/src/components/Navbar.jsx" 
                data-component-line="115:17" 
                data-component-id="client/src/components/Navbar.jsx:115:17"
                className="h-11 px-6 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center gap-2 font-medium shadow-md hover:shadow-lg transition-all duration-200"
              >
                <ShoppingCart data-component-path="client/src/components/Navbar.jsx" data-component-line="119:17" data-component-id="client/src/components/Navbar.jsx:119:17" className="w-5 h-5 flex-shrink-0" />
                <span data-component-path="client/src/components/Navbar.jsx" data-component-line="120:17" data-component-id="client/src/components/Navbar.jsx:120:17">Cart (0)</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar